import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import App from './components/App'
import ErrorBoundary from './components/ErrorBoundary'
import ReactDOM from 'react-dom'

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
)
